<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="icon ion-bag"></i>
            <div class="mg-l-20">
              <h4>{{ $t("router.新建生产单") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="br-pagebody" id="offerSkuList">
        <div class="card bd-gray-400 mg-x-20 pd-0 mg-t-30">
          <div class="d-flex align-items-center justify-content-between pd-20">
            <h5 class="mg-b-0 tx-gray-300">{{ $t("order.商品信息") }}</h5>
            <a href="javascript:;" class="btn btn-info" @click="addCommodity">{{
              $t("order.添加商品")
            }}</a>
          </div>
          <table class="table mg-b-0 table-contact data-table">
            <thead>
              <tr>
                <th class="wd-lg-300">{{ $t("order.商品信息") }}</th>
                <th class="wd-lg-150">{{ $t("order.商品单价") }}</th>
                <th class="wd-lg-150">{{ $t("order.数量") }}</th>
                <th class="wd-lg-150">{{ $t("order.总价") }}</th>
                <th class="wd-lg-150">{{ $t("order.操作") }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="skuItems.length > 0">
                <tr
                  class="tx-12"
                  v-for="(item, index) in skuItems"
                  :key="index"
                >
                  <!-- 商品信息 -->
                  <td class="valign-middle">
                    <div class="media d-block d-sm-flex align-items-center">
                      <a
                        class="p-img-wrap mg-x-5"
                        href="javascript:;"
                        v-lazy:background-image="item.propertyImage"
                      >
                      </a>
                      <div class="p-info">
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.商品：") }}
                          <span class="tx-white">{{ item.skuName }}</span>
                        </p>
                        <p class="mg-b-0 tx-12">
                          SKU:
                          <span class="tx-white">{{
                            item.sku ? item.sku : "---"
                          }}</span>
                          <a
                            v-show="item.sku"
                            class="to-clipboard tx-info mg-l-5"
                            href="javascript:;"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </p>
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.重量(g):") }}
                          <span class="tx-white">{{
                            item.weight ? item.weight : "---"
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <!-- 单价 -->
                  <td class="valign-middle">
                    <span>{{ item.price || 0 }}</span>
                  </td>
                  <!-- 数量 -->
                  <td class="valign-middle">
                    <input
                      v-INT
                      class="form-control tx-13 form-control-dark wd-100"
                      v-model="item.newquantity"
                    />
                  </td>
                  <!-- 总价 -->
                  <td class="valign-middle">
                    <span>{{
                      Number(item.newquantity || 0) * Number(item.price)
                    }}</span>
                  </td>
                  <!-- 操作 -->
                  <td class="valign-middle">
                    <a
                      href="javascript:;"
                      class="tx-info tx-underline mg-r-15"
                      @click="showBOM(item.id)"
                      >{{ $t("rm.BOM图") }}</a
                    >
                    <a
                      href="javascript:;"
                      class="tx-info tx-underline"
                      @click="remove(index)"
                      >{{ $t("order.移除") }}</a
                    >
                  </td>
                </tr>
              </template>
              <tr v-if="!skuItems || skuItems.length < 1">
                <td colspan="6">
                  <div class="col-12 none-product">
                    <i class="fa fa-ban"></i
                    >{{ $t("order.没有符合条件的数据") }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mg-x-50 pd-0 mg-y-30">
        <div class="d-flex align-items-center justify-content-between pd-0">
          <div>
            <span
              >{{ $t("order.商品合计：")
              }}<span class="tx-bold tx-danger mg-r-50">{{
                totalPrice
              }}</span></span
            >
            <span
              >{{ $t("order.商品总件数：")
              }}<span class="tx-bold tx-danger">{{ totalQuantity }}</span></span
            >
          </div>
          <a href="javascript:;" class="btn btn-info" @click="creatOrder()">{{
            $t("order.创建订单")
          }}</a>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
    <!-- 选择商品 -->
    <modalAddNewPro></modalAddNewPro>
    <!-- BOM图 -->
    <modalBom :items="items" />
  </div>
</template>

<script>
import modalAddNewPro from "./modal-add-sku.vue";
import modalBom from "@components/modal-bom.vue";

export default {
  components: { modalAddNewPro, modalBom },
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      skuItems: [],
      items: [],
    };
  },
  computed: {
    // 商品合计
    totalPrice() {
      let price = 0;
      this.skuItems.forEach((elem) => {
        price += Number(elem.newquantity || 0) * Number(elem.price);
      });
      return price;
    },
    // 商品总件数
    totalQuantity() {
      let num = 0;
      this.skuItems.forEach((elem) => {
        num += Number(elem.newquantity || 0);
      });
      return num;
    },
  },
  methods: {
    // 添加商品
    addCommodity() {
      $("#modalAddCommodity").modal("show");
    },
    // 创建订单
    creatOrder() {
      let skus = [];
      this.skuItems.forEach((e) => {
        skus.push({
          id: e.id,
          num: e.newquantity || 1,
        });
      });
      this.loading = true;
      $.api_call(
        "api.Production.createProductionOrder",
        {
          skus,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("rm.手工创建生产订单成功"), "success");
            setTimeout(() => {
              this.$router.push("/manufacture-order");
            }, 1000);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 显示BOM图
    showBOM(skuId) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.getBomTree",
        {
          skuId,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            const res = r.Data.Results || {};
            this.items = [
              {
                name: res.name,
                sku: res.sku,
                children: res.children,
              },
            ];
            $("#modalBom").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 删除商品
    remove(i) {
      this.skuItems.splice(i, 1);
      ShowTip(this.$t("order.删除商品成功"), "success");
    },
  },
};
</script>

<style scoped="scoped">
.show-white-style .tx-white {
  color: #343a40 !important;
}
.img-wrap {
  border: 1px rgba(0, 0, 0, 0.3) solid;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.data-table tbody tr.bg-gray-300:hover,
.data-table .hover:hover {
  background-color: #dee2e6 !important;
}
</style>